import { FC } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Button, ButtonProps } from '@frontend/design-system';

type DarkButtonProps = ButtonProps;

export const DarkButton: FC<DarkButtonProps> = (props) => {
  return <Button variant='primary' {...props} css={styles.darkButton} />;
};

const styles = {
  darkButton: css`
    background-color: ${theme.colors.neutral90};
    color: ${theme.colors.white};
    :hover {
      background-color: ${theme.colors.neutral80};
    }
  `,
};
